import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import Toast from 'features/toast/Toast'
import { Toasts } from 'features/toast/toastSlice'

const ToastContainer = () => {
  const { items } = useSelector(state => state.toast)
  const dispatch = useDispatch()

  useEffect(
    () => () => {
      dispatch(Toasts.clear())
    },
    [dispatch]
  )

  return createPortal(
    <div
      className="toast-container"
      style={{
        display: 'flex',
        flexDirection: 'column-reverse',
        position: 'fixed',
        bottom: 50,
        right: 50,
        zIndex: 1200,
      }}>
      {[...items].reverse().map(({ id, message, type, color }) => (
        <Toast type={type} color={color} id={id} key={id}>
          {message}
        </Toast>
      ))}
    </div>,
    window.document.body
  )
}

export default ToastContainer
